import React, { useState } from 'react';
import SubmitAnswerButton from './submitanswersbutton';

const VocabularyTest = ({ questionNumber, onNext, isLastQuestion, questionData, getTotalExamVideoDuration, candidateTestId, timeRemaining, getVideoDuration, isLastQuestionOfSection,currentSection,sectionQuestions }) => {
  const transformQuestionData = (data) => {
    if (!data) return { question: '', word: '', options: [], correct: 0 };
    
    
    if (data.word && Array.isArray(data.options) && typeof data.options[0] === 'string') {
      return {
        question: `What does '${data.word}' mean?`,
        word: data.word,
        options: data.options,
        correct: data.correctAnswer || 0
      };
    }
    
    
    if (data.options && data.options.length > 0 && typeof data.options[0] === 'object') {
      const sortedOptions = [...data.options].sort((a, b) => a.orderNumber - b.orderNumber);
      const optionsArray = sortedOptions.map(opt => opt.optionText);
      const correctIndex = sortedOptions.findIndex(opt => opt.isCorrect === true);
      
      return {
        question: data.text,
        word: data.text,
        options: optionsArray,
        correct: correctIndex >= 0 ? correctIndex : 0
      };
    }
    
    return { question: '', word: '', options: [], correct: 0 };
  };
  
  const currentQuestion = transformQuestionData(questionData);
  
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionId, setSelectedOptionId] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleOptionSelect = (index) => {
    if (!isSubmitted) {
      setSelectedOption(index);
      // Get the option ID from questionData if available
      if (questionData?.options && questionData.options[index]) {
        setSelectedOptionId(questionData.options[index].id);
      }
    }
  };

  return (
    <div className="test-type-container">
      <div className="step-question">
        <h3 className="question-title">{currentQuestion.question}</h3>
      </div>

      <div className="vocabulary-options">
        {currentQuestion.options.map((option, index) => (
          <button
            key={index}
            className={`option-btn ${selectedOption === index ? 'selected' : ''}`}
            onClick={() => handleOptionSelect(index)}
            disabled={isSubmitted}
          >
            <span className="option-letter">{String.fromCharCode(65 + index)}.</span>
            <span className="option-text">{option}</span>
          </button>
        ))}
      </div>

      <div className="action-buttons">
        
          <SubmitAnswerButton
            questionNumber={questionNumber}
            questionData={questionData}
            candidateTestId={candidateTestId}
            isLastQuestion={isLastQuestion}
            isLastQuestionOfSection={isLastQuestionOfSection} 
            onNext={onNext}
            selectedOptionId={selectedOptionId}
            testType="multiple-choice"
            hasRecorded={true}
            timeRemaining={timeRemaining}
            // disabled={selectedOption === null}
            getVideoDuration={getVideoDuration}
            getTotalExamVideoDuration={getTotalExamVideoDuration}
            section={currentSection}
            sectionQuestions={sectionQuestions}
          />
        
      </div>
    </div>
  );
};

export default VocabularyTest;
